import React from 'react'
import axios from 'axios'

// locales
import i18n from './i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// components
import Card from "./components/bootstrap/Card";
import Collapse from './components/Collapse';
import Sort from './components/Sort';
import ArtOverview from './components/art/ArtOverview';
import Language from './components/_research/ResearchLanguage';
import ToggleLanguage from './components/_research/ToggleLanguage';
import Addmore from './components/Addmore';
import { setCookie, getCookie, eraseCookie } from './utils/Cookie';

// vars
// import { SORT_ARRAY } from "./utils/const";
// import { SEARCH } from "./utils/const";
import { IS_DEBUG } from './utils/isdebug';
// import { LanguageOut } from './utils/LanguageOut';

class App extends React.Component {

	sortArr = i18n.t('sorting.array', { returnObjects: true });

	COOKIE_ARTIST = 'ing-art-artist-title';
	COOKIE_LOCATION = 'ing-art-location';
	COOKIE_TYPE = 'ing-art-type';
	COOKIE_THEME = 'ing-art-theme';
	COOKIE_PERIOD = 'ing-art-period';
	COOKIE_PERIOD_BETWEEN = 'ing-art-period-between';
	COOKIE_PERIOD_BETWEEN_START = 'ing-art-period-between-start';
	COOKIE_PERIOD_BETWEEN_END = 'ing-art-period-between-end';
	COOKIE_SEARCH = 'ing-art-search';
	COOKIE_SEARCH_TYPE = 'ing-art-search-type';
	COOKIE_SEARCH_TYPE_DETAIL = 'ing-art-search-type-detail';

	// every cookie should be reset, but not the search cookies
	cookieArray = [
		this.COOKIE_ARTIST,
		this.COOKIE_LOCATION,
		this.COOKIE_TYPE,
		this.COOKIE_THEME,
		this.COOKIE_PERIOD,
		this.COOKIE_PERIOD_BETWEEN,
		this.COOKIE_PERIOD_BETWEEN_START,
		this.COOKIE_PERIOD_BETWEEN_END,
		// this.COOKIE_SEARCH,
		// this.COOKIE_SEARCH_TYPE,
		// this.COOKIE_SEARCH_TYPE_DETAIL,
	];

	constructor(props) {
		super(props);

		console.log(document.cookie);

		this.amount = 20;
		this.originalData = [];
		this.state = {
			setArtistTitle: (getCookie(this.COOKIE_ARTIST) != null) ? getCookie(this.COOKIE_ARTIST) : '',
			setType: (getCookie(this.COOKIE_TYPE) != null) ? getCookie(this.COOKIE_TYPE) : '',
			setPeriod: (getCookie(this.COOKIE_PERIOD) != null) ? getCookie(this.COOKIE_PERIOD) : '',
			setPeriodStart: (getCookie(this.COOKIE_PERIOD_BETWEEN_START) != null) ? getCookie(this.COOKIE_PERIOD_BETWEEN_START) : '',
			setPeriodEnd: (getCookie(this.COOKIE_PERIOD_BETWEEN_END) != null) ? getCookie(this.COOKIE_PERIOD_BETWEEN_END) : '',
			setTheme: (getCookie(this.COOKIE_THEME) != null) ? getCookie(this.COOKIE_THEME) : '',
			setLocation: (getCookie(this.COOKIE_LOCATION) != null) ? getCookie(this.COOKIE_LOCATION) : '',

			isSearchSelected: false,
			searchType: (getCookie(this.COOKIE_SEARCH_TYPE) != null) ? getCookie(this.COOKIE_SEARCH_TYPE) : '',
			searchTypeDetail: (getCookie(this.COOKIE_SEARCH_TYPE_DETAIL) != null) ? getCookie(this.COOKIE_SEARCH_TYPE_DETAIL) : '',

			setsort: '',
			total: this.amount,
			original: [],
			art: [],
			sortedArt: [],

			autocompleteArr: [],
			typeArr: [],
			periodArr: [],
			themeArr: [],
			themeImgArr: [],
			locationArr: [],
		}

		i18n.changeLanguage(window.ING_Art_language);
		this.sortArr = i18n.t('sorting.array', { returnObjects: true });

		this.isDebug = IS_DEBUG();

		if (this.isDebug) {
			console.log('set vars in html document: language: ' + window.ING_Art_language);
			console.log('set vars in html document: ING_Art_dataUrl: ' + window.ING_Art_dataUrl);
			console.log('set vars in html document: debugMode: ' + window.ING_Art_debugMode);
		}
	}

	componentDidMount() {
		// LanguageOut();

		let dataUrl = 'data.json';
		if (window.ING_Art_dataUrl !== undefined) {
			dataUrl = window.ING_Art_dataUrl;
		}

		/**
		 * 1. is `window.json` defined, use that data
		 * 2. is `window.ING_Art_dataUrl` undefined, use `data.json`
		 * 3. is `window.ING_Art_dataUrl` defined, use the name given in that var
		 */
		// if (this.isDebug) {
		// 	console.log('componentDidMount() :: data url: ' + dataUrl);
		// 	console.log(window.json);
		// 	console.log(window.json !== undefined);
		// }

		// complexity by ING, we need to embed the data in the html page...
		if (window.json !== undefined) {
			const art = window.json.data;
			// console.log('art');
			// console.log(art);
			this.originalData = art;
			// console.log(this.originalData);
			this.setState({ art: art, original: art });
			// console.log(this.state.original);
			this.convertData();
		} else {
			axios.get(dataUrl)
				.then(res => {
					const art = res.data.data;
					this.originalData = art;
					this.setState({ art: art, original: art });
					this.convertData();
				}, error => {
					console.log(error);
				});
		}
	}

	componentWillUnmount() { }

	// ____________________________________ render ____________________________________

	render() {
		let artData = this.filterSortData();
		// if (this.isDebug) console.log(artData);

		let totalArtVisible = (artData.length >= this.state.total) ? this.state.total : artData.length;
		let totalArt = artData.length;

		const styles = { paddingTop: "40px", paddingBottom: "40px", };

		return (
			<>
				{this.debugComponents()}

				<div className="container-gray" style={styles} >
					<div className="container">


						<Collapse
							onArtistTitleClick={(e) => this.onArtistTitleClick(e)}
							onTypeClick={(e) => this.onTypeClick(e)}
							onPeriodClick={(e) => this.onPeriodClick(e)}
							onPeriodBetweenClick={(e, start, end) => this.onPeriodBetweenClick(start, end)}
							onThemeClick={(e) => this.onThemeClick(e)}
							onLocationClick={(e) => this.onLocationClick(e)}
							onApplyClick={(e, searchType, searchTypeDetail) => this.onApplyClick(searchType, searchTypeDetail)}
							onReset={() => this.reset()}

							isSearchSelected={this.state.isSearchSelected}
							searchType={this.state.searchType}
							searchTypeDetail={this.state.searchTypeDetail}

							autocompleteArray={this.state.autocompleteArr}
							typeArray={this.state.typeArr}
							themeArray={this.state.themeArr}
							themeImgArray={this.state.themeImgArr}
							locationArray={this.state.locationArr}
							periodArray={this.state.periodArr}

							stateArtistTitle={this.state.setArtistTitle}
							stateType={this.state.setType}
							statePeriod={this.state.setPeriod}
							statePeriodStart={this.state.setPeriodStart}
							statePeriodEnd={this.state.setPeriodEnd}
							stateTheme={this.state.setTheme}
							stateLocation={this.state.setLocation}
						/>
					</div>
				</div>

				<div className="container container-white-triangle">
					<div className="container-sorting">
						<div className="row align-items-center">
							<div className="col-12 col-md-4">
								<p className="small">{i18n.t('collection.result', { current: totalArtVisible, total: totalArt })}</p>
							</div>
							<div className="col-12 col-md-auto">
								<Sort onChange={(e) => this.onSortClick(e)} />
							</div>
						</div>
						{/* /.row */}
					</div>
				</div>


				<div className="container-fluid">
					<ArtOverview array={JSON.stringify(artData)} total={this.state.total} />
				</div>

				{this.getDebugOverview(artData)}

				<Addmore onClick={() => this.handleClick()} current={totalArtVisible} total={totalArt} />

			</>
		)
	}

	// ____________________________________ debug data ____________________________________

	getDebugOverview(artData) {
		var template = null;
		if (this.isDebug) template =
			<div className="container-xl">
				<div className="row row justify-content-center">
					{
						artData.map((art, index) => {
							if (index <= this.state.total)
								return (
									<div className="col col-12 col-md-6 col-lg-4" key={index}>
										<Card art={art} id={index} />
									</div>
								)
							else
								return null;
						})
					}
				</div>
			</div>
		return template;
	}

	debugComponents() {
		let templates = null;
		if (this.isDebug) templates =
			<div className="container">
				<p>
					<a className="btn btn-danger" data-toggle="collapse" href="#collapseTestData" role="button" aria-expanded="false" aria-controls="collapseTestData">
						toggle test data</a>
				</p>
				<div className="collapse" id="collapseTestData">

					<h3>ING-Art collection</h3>

					<ToggleLanguage />
					<Language />

					<div className="row">
						<div className="col">
							<div className="alert alert-success">
								Debug
								<ul>
									<li>setArtistTitle: '{this.state.setArtistTitle}'</li>
									<li>setType: '{this.state.setType}'</li>
									<li>setPeriod: '{this.state.setPeriod}'</li>
									<li>setTheme: '{this.state.setTheme}'</li>
									<li>setLocation: '{this.state.setLocation}'</li>
									<li>setsort: '{this.state.setsort}'</li>
									<li>isSearchSelected: {(this.state.isSearchSelected) ? 'true' : 'false'}</li>
									<li>searchType: {(this.state.searchType)}</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>;
		return templates;
	}

	// ____________________________________ data convert ____________________________________

	convertData() {
		// let data = this.state.original;
		let data = this.originalData;

		let titleArray = [];
		let artistArray = [];
		let themeArray = [];
		let typeArray = [];
		let locationArray = [];
		let themeImgArray = [];
		let periodArray = [];
		let autocompleteArray = [];
		data.forEach(artz => {
			// console.log(artz.title);
			// title
			if (!titleArray.includes(artz.title))
				titleArray.push(artz.title);
			// & artist
			if (!artistArray.includes(artz.artist))
				artistArray.push(artz.artist);
			// theme
			if (artz.theme == null || artz.theme === '') artz.theme = 'Other';
			if (!themeArray.includes(artz.theme))
				themeArray.push(artz.theme);
			// theme image
			// console.log(artz.theme, artz.themeImage);

			themeImgArray[artz.theme] = artz.themeImage;
			// type
			if (!typeArray.includes(artz.type))
				typeArray.push(artz.type);

			// period
			if (artz.period == null || artz.period === '') artz.period = 'Other';
			if (!periodArray.includes(artz.period))
				periodArray.push(artz.period);

			// console.log(artz.location); // null?????
			// location
			if (artz.location == null || artz.location === '') artz.location = 'Other';
			// [mck] might want to remove the values from the default locationArray `LOCATION_ARRAY`
			if (!locationArray.includes(artz.location))
				locationArray.push(artz.location);
		});

		autocompleteArray = titleArray.concat(artistArray).sort();
		themeArray.sort();
		typeArray.sort();
		locationArray.sort();
		periodArray.sort();


		// console.log(themeImgArray);
		this.setState({
			autocompleteArr: autocompleteArray,
			themeArr: themeArray,
			typeArr: typeArray,
			locationArr: locationArray,
			themeImgArr: themeImgArray,
			periodArr: periodArray,
		})
	}

	// ____________________________________ filtering and sorting ____________________________________

	filterSortData() {
		var data = this.state.original;
		// var data = this.originalData;

		if (this.state.setLocation !== '') {
			data = data.filter(art => art.location === this.state.setLocation);
		}
		if (this.state.setType !== '') {
			data = data.filter(art => art.type === this.state.setType);
		}
		if (this.state.setPeriod !== '') {
			data = data.filter(art => art.period === this.state.setPeriod);
		}
		if (this.state.setTheme !== '') {
			data = data.filter(art => art.theme === this.state.setTheme);
		}
		if (this.state.setArtistTitle !== '') {
			data = data.filter(art => art.title === this.state.setArtistTitle || art.artist === this.state.setArtistTitle);
		}
		if (this.state.setPeriodStart !== '') {
			data = data.filter(art => art.creation_year >= this.state.setPeriodStart && art.creation_year <= this.state.setPeriodEnd);
		}


		// sorting as last over data
		if (this.state.setsort === this.sortArr[0] || this.state.setsort === '') {
			// console.log("> Recent purchase - Latest first");
			data = data.sort((a, b) => b.purchase_year - a.purchase_year)
		}
		if (this.state.setsort === this.sortArr[1]) {
			// console.log("> Recent purchase - Oldest first");
			data = data.sort((a, b) => a.purchase_year - b.purchase_year)
		}
		if (this.state.setsort === this.sortArr[2]) {
			// console.log("> Year of creation - Latest first");
			data = data.sort((a, b) => b.creation_year - a.creation_year)
		}
		if (this.state.setsort === this.sortArr[3]) {
			// console.log("> Year of creation - Oldest first");
			data = data.sort((a, b) => a.creation_year - b.creation_year)
		}

		// this.setState({
		// 	sortedArt: data
		// });
		return data;
	}

	// ____________________________________ resetting data ____________________________________

	reset() {
		this.setState({
			setArtistTitle: '',
			setType: '',
			setPeriod: '',
			setPeriodStart: '',
			setPeriodEnd: '',
			setTheme: '',
			setLocation: '',
			total: this.amount,
			isSearchSelected: false,
			searchType: '',
			searchTypeDetail: '',
		})
	}

	// ____________________________________ cookie ____________________________________

	cookie2(name, value1, value2) {
		console.log('COOKIE 2 -- name: ' + name + ',  value1: ' + value1 + ',  value2: ' + value2);
		console.log('current cookie 2: ' + document.cookie);
		// set new cookie
		switch (name) {
			case this.COOKIE_SEARCH:
				// console.warn(name);
				setCookie(this.COOKIE_SEARCH_TYPE, value1, 1);
				setCookie(this.COOKIE_SEARCH_TYPE_DETAIL, value2, 1);
				break;
			case this.COOKIE_PERIOD_BETWEEN:
				// reset old cookies
				for (let i = 0; i < this.cookieArray.length; i++) {
					const name = this.cookieArray[i];
					eraseCookie(name);
				}
				setCookie(this.COOKIE_PERIOD_BETWEEN_START, value1, 1);
				setCookie(this.COOKIE_PERIOD_BETWEEN_END, value2, 1);
				setCookie(this.COOKIE_SEARCH_TYPE_DETAIL, `${value1} - ${value2}`, 1);
				break;
			default:
				break;
		}
		console.log('new cookie 2: ' + document.cookie);
	}

	cookie(name, value) {
		console.log('COOKIE -- name: ' + name + ',  value: ' + value);
		console.log('current cookie: ' + document.cookie);

		// reset old cookies
		for (let i = 0; i < this.cookieArray.length; i++) {
			const name = this.cookieArray[i];
			eraseCookie(name);
		}
		setCookie(name, value, 1);
		console.log('new cookie: ' + document.cookie);
	}

	// ____________________________________ onHandlers ____________________________________


	onApplyClick(searchType, searchTypeDetail) {
		// console.log('searchType: ' + searchType);
		// console.log('searchTypeDetail: ' + searchTypeDetail);
		// this.reset();
		// first onClick handler
		// then onApplyClick
		this.setState({
			isSearchSelected: true,
			searchType: searchType,
			searchTypeDetail: searchTypeDetail
		});
		// console.warn('onApplyClick: ' + this.COOKIE_SEARCH + ' - searchType: ' + searchType + ' - searchTypeDetail: ' + searchTypeDetail);
		this.cookie2(this.COOKIE_SEARCH, searchType, searchTypeDetail);
	}

	onArtistTitleClick(e) {
		// title/artist name
		// console.log('---->', e);
		this.reset();
		this.setState({
			setArtistTitle: e,
		});
		this.cookie(this.COOKIE_ARTIST, e);
	}

	onLocationClick(e) {
		// console.log(document.cookie);
		this.reset();
		this.setState({
			setLocation: e,
		});
		this.cookie(this.COOKIE_LOCATION, e);
	}

	onTypeClick(e) {
		this.reset();
		this.setState({
			setType: e,
		});
		this.cookie(this.COOKIE_TYPE, e);
	}

	onPeriodClick(e) {
		this.reset();
		this.setState({
			setPeriod: e,
		});
		this.cookie(this.COOKIE_PERIOD, e);
	}

	onPeriodBetweenClick(start, end) {
		// console.log('start: ' + start);
		// console.log('end: ' + end);
		this.reset();
		this.setState({
			setPeriodStart: start,
			setPeriodEnd: end,
		});
		// console.warn('onPeriodBetweenClick: ' + this.COOKIE_SEARCH + ' - start: ' + start + ' - end: ' + end);
		this.cookie2(this.COOKIE_PERIOD_BETWEEN, start, end);
	}

	onThemeClick(e) {
		this.reset();
		this.setState({
			setTheme: e,
		});
		this.cookie(this.COOKIE_THEME, e);
	}

	onSortClick(e) {
		// [mck] this might change in the future, sorting might be without the reset...
		console.log('onSortClick: e: ' + e);
		this.reset();
		this.setState({
			setsort: e,
		});
	}

	handleClick() {
		this.setState({ total: this.state.total + this.amount });
	}

}
export default withTranslation()(App);